import React, { useState } from "react";
import "./SeguridadCuenta.css";
import { cambiarPassword } from "../../../../services/auth";

const SeguridadCuenta = () => {
  const [passwordData, setPasswordData] = useState({
    actual: "",
    nueva: "",
    confirmar: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isValid, setIsValid] = useState(false);

  // Validación de la nueva contraseña
  const validatePassword = (password) => {
    const minLength = password.length >= 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    return minLength && hasUpperCase && hasNumber && hasSpecialChar;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validar nueva contraseña y coincidencia
    if (name === "nueva" || name === "confirmar") {
      const isPasswordValid = validatePassword(passwordData.nueva);
      const doPasswordsMatch =
        name === "confirmar"
          ? value === passwordData.nueva
          : passwordData.confirmar === value;

      if (!value) {
        setError("");
        setIsValid(false);
      } else if (!isPasswordValid) {
        setError(
          "La nueva contraseña debe tener al menos 8 caracteres, una mayúscula, un número y un carácter especial."
        );
        setIsValid(false);
      } else if (!doPasswordsMatch) {
        setError("Las contraseñas no coinciden.");
        setIsValid(false);
      } else {
        setError("");
        setIsValid(true);
      }
    }
  };

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isValid) {
      try {
        await cambiarPassword({
          old_password: passwordData.actual,
          new_password1: passwordData.nueva,
          new_password2: passwordData.confirmar,
        });
        alert("Contraseña actualizada con éxito.");
        setPasswordData({ actual: "", nueva: "", confirmar: "" });
      } catch (err) {
        setError("Error al cambiar la contraseña. Verifica tus datos.");
      }
    }
  };

  return (
    <div className="seguridad-cuenta">
      <h2>Seguridad de la Cuenta</h2>
      <h3>Cambio de Contraseña</h3>
      <form onSubmit={handleSubmit}>
        {/* Contraseña actual */}
        <div className="form-group">
          <label htmlFor="actual">Contraseña Actual</label>
          <input
            type={showPassword ? "text" : "password"}
            id="actual"
            name="actual"
            value={passwordData.actual}
            onChange={handleInputChange}
            required
          />
        </div>

        {/* Nueva contraseña */}
        <div className="form-group">
          <label htmlFor="nueva">Nueva Contraseña</label>
          <input
            type={showPassword ? "text" : "password"}
            id="nueva"
            name="nueva"
            value={passwordData.nueva}
            onChange={handleInputChange}
            required
          />
        </div>

        {/* Confirmar nueva contraseña */}
        <div className="form-group">
          <label htmlFor="confirmar">Confirmar Nueva Contraseña</label>
          <input
            type={showPassword ? "text" : "password"}
            id="confirmar"
            name="confirmar"
            value={passwordData.confirmar}
            onChange={handleInputChange}
            required
          />
        </div>

        {/* Botón para mostrar/ocultar contraseña */}
        <div className="form-group">
          <button type="button" onClick={toggleShowPassword}>
            {showPassword ? "Ocultar Contraseña" : "Mostrar Contraseña"}
          </button>
        </div>

        {/* Mensaje de error */}
        {error && <p className="error-message">{error}</p>}

        {/* Botón de guardar */}
        <button type="submit" disabled={!isValid}>
          Guardar Cambios
        </button>
      </form>
    </div>
  );
};

export default SeguridadCuenta;
